import "./index.css";
import { ReactNode } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import PlausibleAnalytics from "./PlausibleAnalytics";
import { PlutoProvider, PlutoProviderProps } from "@plutoxyz/react-frame";
import { ClerkProvider } from "@clerk/clerk-react";

// Wrap in a safe provider that catches React errors
const SafePlutoProvider = (
  props: PlutoProviderProps & { children: ReactNode },
) => {
  try {
    return <PlutoProvider {...props} />;
  } catch (e) {
    console.error("Error rendering PlutoProvider:", e);
    return props.children;
  }
};

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

if (!PUBLISHABLE_KEY) {
  console.error("Missing Publishable Key");
}

const AppWithProviders = () => (
  <ClerkProvider
    publishableKey={PUBLISHABLE_KEY}
    afterSignOutUrl="/"
    appearance={{
      cssLayerName: "clerk",
    }}
  >
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        width: "100vw",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <SafePlutoProvider>
        <PlausibleAnalytics />
        <App />
      </SafePlutoProvider>
    </div>
  </ClerkProvider>
);

const rootElement = document.getElementById("root");
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(<AppWithProviders />);
}
